// This file is auto-generated by @hey-api/openapi-ts

export type EngagementOverview = {
    userInfo: UserInfo;
    accountOverviews?: Array<AccountOverview>;
    investmentOverview: AccountOverview;
    loanOverviews: LoanOverviewResponse;
};

export type AccountOverview = {
    accountHolder?: string;
    accounts: Array<Account>;
    accountsTotal?: number;
    hasInactiveAccounts?: boolean;
    overviewType?: OverviewType;
};

export enum OverviewType {
    PRIVATE = 'Private',
    SOLE_PROPRIETORSHIP = 'SoleProprietorship',
    COMPANY = 'Company'
}

export type Account = {
    id: string;
    name: string;
    accountNumber: string;
    accountKey: Key;
    interestRate: number;
    amount: number;
    accountHolder?: string;
    status: string;
    openedAt: Date;
    closedAt?: Date;
    productType: string;
    accountPartners?: Array<AccountPartner>;
    bankAccountInfo?: BankAccountInfo;
    accountType: AccountType;
    accountState: AccountState;
};

export type AccountDetailsResponse = {
    accountDetails?: AccountDetails;
};

export type AccountDetails = {
    key: Key;
    name: string;
    productKey: string;
    amount: number;
    accountPartners: Array<AccountPartner>;
    endDate: Date;
    availableAmount: number;
    description: string;
    accruedInterests: number;
    openedAt: Date;
    closedAt: (Date) | null;
    productType: string;
    interestRate: number;
    status: string;
    plannedClosureDate?: Date;
    isActive: boolean;
    accountHolder?: string;
    bankAccountInfo?: BankAccountInfo;
    interestInterval?: Array<InterestInterval>;
};

export type InterestInterval = {
    interestRate: number;
    amountLimit: number;
};

export type AccountPartner = {
    fullname: string;
    percentage: number;
    roleId: string;
    roleType: RoleType;
    partyId: string;
};

export type LoanOverviewResponse = {
    collaterals: Array<LoanOverview>;
    others: Array<LoanOverview>;
};

export type LoanOverview = {
    collateralName?: string;
    loans: Array<Loan>;
    totalLoanAmount?: number;
    overviewType?: OverviewType;
};

export type Loan = {
    id: string;
    loanNumber: string;
    product: LoanType;
    loanType: string;
    loanKey: Key;
    amortizationAmount?: number;
    loanAmount?: number;
    interestRate?: number;
    status?: LoanStatus;
    isCanceled: boolean;
    roles: Array<RoleType>;
};

export type UserInfo = {
    firstName: string;
    lastName: string;
};

export type ChangeAccountNameRequest = {
    name: string;
};

export type Transaction = {
    amount: number;
    balance: number;
    transactionDate: Date;
    description: string;
    transactionTypeCode: string;
    transactionType: TransactionType;
    note: string;
    toAccount?: BankAccountInfo;
    valueDate: Date;
};

export type BankAccountInfo = {
    accountNumber: string;
    accountKey: Key;
    bankName: string;
    bankKey: string;
    clearingNumber: string;
    isValid: boolean;
};

export enum TransactionType {
    WITHDRAWAL = 'Withdrawal',
    DEPOSIT = 'Deposit'
}

export type Profile = {
    id: string;
    name: string;
    firstName?: string;
    lastName?: string;
    ssn: string;
    isDefault: boolean;
    roles?: Array<RoleType>;
    profileType: ProfileType;
};

export enum LoanStatus {
    UNKNOWN = 'Unknown',
    ACTIVE = 'Active',
    CONTRACT_TERMINATED = 'ContractTerminated',
    POTENTIAL_LOSS = 'PotentialLoss',
    LOSS = 'Loss',
    NO_BOOKING = 'NoBooking',
    TERMINATION_PLANNED = 'TerminationPlanned',
    TECHNICALLY_TERMINATED = 'TechnicallyTerminated'
}

export type InternetAgreement = {
    accepted?: boolean;
    acceptedAt?: Date;
    version?: string;
};

export type NotAcceptedInternetAgreement = {
    agreementId?: string;
};

export type InternetAgreementVersion = {
    agreementId: string;
    version: string;
    showFrom?: Date;
    validFrom?: Date;
    validTo?: Date;
    mandatory: boolean;
    url: string;
};

export enum RoleType {
    Unknown = 0,
    AccountHolder = 1,
    RightOfDisposition = 2,
    Addressee = 3,
    ContactPerson = 4,
    Stakeholder = 5,
    Employees = 6,
    OrganizationalUnit = 7,
    InternetUser = 8,
    Intermediator = 9,
    BorrowerUnit = 10,
    MainBorrower = 11,
    Borrower = 12,
    CoBorrower = 13,
    Guarantor = 14,
    Owner = 15,
    Applicant = 16,
    CoApplicant = 17,
    InvoiceRecipient = 18,
    Creditor = 19,
    Pledger = 20,
    TenantOwnerAssociation = 21,
    CoAccountHolder = 22,
    ExposureClassNaturalPerson = 23,
    ExposureClassHouseholdSME = 24,
    ExposureClassOrganizations = 25,
    Household = 26,
    CustomerCategoryNaturalPerson = 27,
    ManualCustomerCategoryNaturalPerson = 28,
    CustomercategoryMediumSizeBusinesses = 29,
    ManualCustomerCategoryMediumSizeBusinesses = 30,
    CustomerCategoryMicroBusinesses = 31,
    ManualCustomerCategoryMicroBbusinesses = 32,
    CustomerCategorySmallBusinesses = 33,
    ManualCustomerCategorySmallBusinesses = 34,
    LPPPerson = 35,
    LBFLegalEntity = 36,
    LBFNaturalPerson = 37,
    CreditGroup = 38,
    Representative = 39,
    Donor = 40,
    ExternalValuer = 41,
    Trustee = 42,
    ChiefGuardian = 43,
    Guardian = 44,
    Fiduciary = 45,
    Employee = 46,
    MainAddressee = 47,
    BoardMember = 48,
    Custodian = 49,
    Bearer = 50,
    BenificialOwner = 51,
    FutureOwner = 52
}

export enum ProfileType {
    UNKNOWN = 'Unknown',
    PERSONAL = 'Personal',
    SOLE_PROPRIETORSHIP = 'SoleProprietorship',
    PERSONAL_AND_SOLE_PROPRIETORSHIP = 'PersonalAndSoleProprietorship',
    COMPANY = 'Company'
}

export enum MemberState {
    UNKNOWN = 'Unknown',
    NON_MEMBER = 'NonMember',
    MEMBER = 'Member',
    WAITING_PERIOD = 'WaitingPeriod'
}

export type Key = {
    clearingNumber?: string;
    accountNumber?: string;
};

export type ProfileQuickInfo = {
    profileId: string;
    generatedAt: Date;
    name: string;
    profileType: ProfileType;
    memberState?: MemberState;
    changeTermOffers: Array<ChangeTermOffer>;
    relations: Array<{
        profileId?: string;
        relationType?: RelationshipType;
    }>;
    loansInfo: {
        isLoaded: boolean;
        loadedAt: Date;
        loans: Array<LoanInfo>;
    };
    accountsInfo: {
        isLoaded: boolean;
        loadedAt: Date;
        accounts: Array<Account>;
        investmentsAccounts: Array<Account>;
    };
};

export type ChangeTermOffer = {
    validFrom?: Date;
    validTo?: Date;
};

export type LoanInfo = {
    loanNumber: string;
    loanType: LoanType;
};

export enum AccountState {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive'
}

export enum AccountType {
    UNKNOWN = 'Unknown',
    SPARKONTO = 'Sparkonto',
    SPARKONTO_TRYGGHET = 'SparkontoTrygghet',
    SPARKONTO_JORD_OCH_SKOG = 'SparkontoJordOchSkog',
    SPARKONTO_FORETAG = 'SparkontoForetag',
    MEDLEMSKONTO = 'Medlemskonto',
    FASTRANTEPLACERING = 'Fastranteplacering',
    INSATSKAPITAL = 'Insatskapital',
    SKOGSKONTO = 'Skogskonto',
    SKOGSSKADEKONTO = 'Skogsskadekonto',
    FORETAGSKONTO = 'Foretagskonto'
}

export enum LoanType {
    UNKNOWN = 'Unknown',
    BOTTENLAN = 'Bottenlan',
    FLEXIBELT_BOTTENLAN = 'FlexibeltBottenlan',
    BOTTENLAN_STIBOR = 'BottenlanStibor',
    LAN_FORETAG = 'LanForetag',
    BOLAN_GARD = 'BolanGard',
    BOLAN = 'Bolan',
    PERSONALLAN = 'Personallan',
    EUKREDIT_A60 = 'EUkreditA60',
    LAN_TOPP_SEKUNDARLAN = 'LanToppSekundarlan',
    EUKREDIT_C10 = 'EUKreditC10'
}

export enum RelationshipType {
    UNKNOWN = 'Unknown',
    POWER_OF_ATTOURNEY = 'PowerOfAttourney',
    GUARDIAN = 'Guardian',
    TRUSTEE = 'Trustee',
    FIDUCIARY = 'Fiduciary',
    PART_OF_AHOUSEHOLD = 'PartOfAHousehold',
    INTERNET_BANK_USER = 'InternetBankUser',
    ACCESS_ADMINISTRATOR = 'AccessAdministrator',
    RIGHT_OF_DISPOSITION = 'RightOfDisposition',
    PART_OF_ACREDIT_GROUP = 'PartOfACreditGroup',
    SPECIAL_MANAGEMENT = 'SpecialManagement',
    BENIFICIAL_OWNER = 'BenificialOwner'
}

export type FutureTransactionsResponse = {
    transactions: Array<FutureTransaction>;
};

export type FutureTransaction = {
    id: string;
    fromAccount?: BankAccountInfo;
    toAccount?: BankAccountInfo;
    plannedTransactionDate: Date;
    amount: number;
    isStandingOrder: boolean;
    bankArea: string;
    standingOrderEndDate?: Date;
    standingOrderExecutionDate?: Date;
    standingOrderFrequencyInDays?: number;
};

export type InvestmentInfo = {
    investmentLimit?: number;
    deferredInvestment?: number;
    excessInvestment?: number;
};

export type InvestmentAmounts = {
    investmentLimit: number;
    deferredInvestment: number;
    excessInvestment: number;
    totalAmountFixedRateInvestement: number;
    remainingRoomForInvestment: number;
};

export type CreateInvestmentOrderRequest = {
    fromAccount: string;
    toAccount: string;
    amount: number;
};

export type OrderResponse = {
    orderId: string;
    autoStartToken: string;
};

export type CompleteInvestmentOrderRequest = {
    orderId: string;
};

export type OrderCompletedResponse = {
    successful: boolean;
    message?: string;
};

export type CheckOrderResponse = {
    status: CheckOrderStatus;
};

export enum CheckOrderStatus {
    Complete = 0,
    UserSign = 1,
    OutstandingTransaction = 2,
    NoClient = 3,
    UserReq = 4,
    Started = 5,
    Failed = 6,
    Unknown = 100
}

export type ContactInformation = {
    email?: string;
    mobile?: string;
    lastUpdatedEmail?: Date;
    lastUpdatedMobile?: Date;
    contactOutdated?: boolean;
    userHasAccess?: boolean;
};

export type UpdateContactInformationRequest = {
    email: string;
    mobile: string;
};

export type AcceptInternetAgreementRequest = {
    profileId: string;
    version?: string;
};

export type GetProfilesData = {
    query?: {
        forceRefresh?: boolean;
    };
};

export type GetProfilesResponse = (Array<Profile>);

export type GetProfilesError = unknown;

export type GetEngagementOverviewData = {
    path: {
        profileId: string;
    };
};

export type GetEngagementOverviewResponse = (EngagementOverview);

export type GetEngagementOverviewError = unknown;

export type GetLoanOverviewsData = {
    path: {
        profileId: string;
    };
};

export type GetLoanOverviewsResponse = (LoanOverviewResponse);

export type GetLoanOverviewsError = unknown;

export type GetAccountOverviewsData = {
    path: {
        profileId: string;
    };
    query?: {
        activeAccounts?: boolean;
    };
};

export type GetAccountOverviewsResponse = (Array<AccountOverview>);

export type GetAccountOverviewsError = unknown;

export type GetAccountDetailsData = {
    path: {
        accountNumber: string;
        area: string;
        profileId: string;
    };
};

export type GetAccountDetailsResponse = (AccountDetails);

export type GetAccountDetailsError = unknown;

export type GetInvestmentOverviewsData = {
    path: {
        profileId: string;
    };
};

export type GetInvestmentOverviewsResponse = (AccountOverview);

export type GetInvestmentOverviewsError = unknown;

export type GetInternetAgreementData = {
    path: {
        agreementId: string;
        profileId: string;
    };
};

export type GetInternetAgreementResponse = (InternetAgreement | void);

export type GetInternetAgreementError = unknown;

export type GetNotAcceptedInternetAgreementData = {
    path: {
        profileId: string;
    };
};

export type GetNotAcceptedInternetAgreementResponse = (NotAcceptedInternetAgreement);

export type GetNotAcceptedInternetAgreementError = unknown;

export type GetInvestmentAmountsData = {
    path: {
        profileId: string;
    };
};

export type GetInvestmentAmountsResponse = (InvestmentAmounts);

export type GetInvestmentAmountsError = unknown;

export type GetProfileQuickInfoData = {
    path: {
        profileId: string;
    };
};

export type GetProfileQuickInfoResponse = (ProfileQuickInfo);

export type GetProfileQuickInfoError = unknown;

export type GetContactInformationData = {
    path: {
        profileId: string;
    };
};

export type GetContactInformationResponse = (ContactInformation);

export type GetContactInformationError = unknown;

export type AcceptInternetAgreementData = {
    body: AcceptInternetAgreementRequest;
    path: {
        agreementId: string;
    };
};

export type AcceptInternetAgreementResponse = (InternetAgreement);

export type AcceptInternetAgreementError = unknown;

export type GetInternetAgreementVersionsData = {
    path: {
        agreementId: string;
    };
    query?: {
        latest?: boolean;
    };
};

export type GetInternetAgreementVersionsResponse = (Array<InternetAgreementVersion>);

export type GetInternetAgreementVersionsError = unknown;

export type GetInvestmentInformationResponse = (InvestmentInfo);

export type GetInvestmentInformationError = unknown;

export type GetInvestmentInformationForProfileData = {
    path: {
        profileId: string;
    };
};

export type GetInvestmentInformationForProfileResponse = (InvestmentInfo);

export type GetInvestmentInformationForProfileError = unknown;

export type GetAccountTransactionsData = {
    path: {
        accountNumber: string;
        area: string;
    };
    query?: {
        fromDate?: Date;
        toDate?: Date;
    };
};

export type GetAccountTransactionsResponse = (Array<Transaction>);

export type GetAccountTransactionsError = unknown;

export type SetAccountNameData = {
    body: ChangeAccountNameRequest;
    path: {
        accountNumber: string;
        area: string;
        profileId: string;
    };
};

export type SetAccountNameResponse = (void);

export type SetAccountNameError = unknown;

export type GetFutureTransactionsData = {
    path: {
        profileId: string;
    };
};

export type GetFutureTransactionsResponse = (FutureTransactionsResponse);

export type GetFutureTransactionsError = unknown;

export type DeleteFutureTransactionData = {
    path: {
        profileId: string;
        transactionId: string;
    };
};

export type DeleteFutureTransactionResponse = (void);

export type DeleteFutureTransactionError = unknown;

export type CreateInvestmentOrderData = {
    body: CreateInvestmentOrderRequest;
};

export type CreateInvestmentOrderResponse = (OrderResponse);

export type CreateInvestmentOrderError = unknown;

export type CompleteInvestmentOrderData = {
    body: CompleteInvestmentOrderRequest;
};

export type CompleteInvestmentOrderResponse = (OrderCompletedResponse);

export type CompleteInvestmentOrderError = unknown;

export type CheckOrderData = {
    path: {
        orderId: string;
    };
};

export type CheckOrderResponse2 = (CheckOrderResponse);

export type CheckOrderError = unknown;

export type UpdateContactInformationData = {
    body: UpdateContactInformationRequest;
    path: {
        profileId: string;
    };
};

export type UpdateContactInformationResponse = (ContactInformation);

export type UpdateContactInformationError = unknown;